import { useState } from 'react';
import { useAuth } from '@/contexts/auth-context';
import { toast } from '@/hooks/use-toast';

export const usePhieuXuatTraLaiNhaCungCapExport = () => {
  const [isExporting, setIsExporting] = useState(false);
  const { entity } = useAuth();

  const exportToExcel = async () => {
    setIsExporting(true);
    try {
      const { exportPhieuXuatTraLaiNhaCungCapExcel, exportPhieuXuatTraLaiNhaCungCapFromApi } =
        await import('../utils/export-excel');
      if (entity?.slug) {
        await exportPhieuXuatTraLaiNhaCungCapFromApi({
          entitySlug: entity.slug
        });
        return;
      }

      await exportPhieuXuatTraLaiNhaCungCapExcel();
    } catch (error) {
      toast({
        description: 'Không thể kết xuất dữ liệu.',
        variant: 'destructive'
      });
    } finally {
      setIsExporting(false);
    }
  };

  return {
    exportToExcel,
    canExport: Boolean(entity?.slug),
    isExporting
  };
};
